/* eslint-disable react/prefer-stateless-function */
import React, { Fragment, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import {
  withStyles, Grow, Paper, Popper 
} from '@material-ui/core';

const styles = () => ({
  paper: {
    padding: '3px 8px',
    textAlign: 'center',
    backgroundColor: '#000',
    maxWidth: 200
  },
  content: {
    fontSize: '12px',
    color: '#FFF'
  },
  popperShowed: {
    zIndex: 10000
  },
  popperHidden: {
    zIndex: -1
  }
});

function Tooltip({
  content, classes, placement, tooltip, minimalWidth
}) {
  const [target, setTarget] = useState(null);

  const showPopover = (e) => {
    setTarget(e.target);
  };

  const hidePopover = () => {
    setTarget(null);
  };

  const show = useMemo(
    () => Boolean(target),
    [target]
  );

  return (
    <>
      <div
        onMouseEnter={showPopover}
        onMouseLeave={hidePopover}
        onFocus={showPopover}
        onBlur={hidePopover}
        aria-describedby={show ? 'mouse-over-popover' : undefined}
      >
        {content}
      </div>
      <Popper
        id="mouse-over-popover"
        placement={placement}
        open={show}
        anchorEl={target}
        className={show ? classes.popperShowed : classes.popperHidden}
      >
        <Grow in={show} style={{ transformOrigin: '0 0 0', width: 'auto' }}>
          <Paper className={classes.paper} style={{ minWidth: minimalWidth }}>
            <div className={classes.content}>
              {tooltip}
            </div>
          </Paper>
        </Grow>
      </Popper>
    </>
  );
}

Tooltip.propTypes = {
  classes: PropTypes.object.isRequired,
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]).isRequired,
  tooltip: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  minimalWidth: PropTypes.string,
  placement: PropTypes.string
};

Tooltip.defaultProps = {
  tooltip: '',
  minimalWidth: '',
  placement: 'top'
};

export default withStyles(styles)(Tooltip);